// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edititem-color-payment {
    background-color: #cfcfcf !important;
    border-radius: 0;
}

.edititem-color-payment a {
    color: #000000 !important;
}

.payment-image {
    width: 100%;
    max-width: 150px;
    height: 50px;
    object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/PaymentSettings.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".edititem-color-payment {\n    background-color: #cfcfcf !important;\n    border-radius: 0;\n}\n\n.edititem-color-payment a {\n    color: #000000 !important;\n}\n\n.payment-image {\n    width: 100%;\n    max-width: 150px;\n    height: 50px;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
